<template>
  <div id="g-page" >  
    <table border="0" id="main-table-screen" >
      <tr>
        <td id="main-table-row1" colspan="1"> 
        </td>
      </tr>

      <tr>
        <td></td>
        <td id="main-table-row2-dialog-container-td">
          <table border="0" style="width:100%" class="dialog-table-radius">
            <tr>
              <td id="dialog-physician" align="center" colspan="1">
                <table border="0">
                  <td id="dialog-physician-title">
                    <!--My Physicians-->
                    {{ $t('myPhysicians.title') }}
                  </td>
                </table>
              </td>            
            </tr>
            <tr>
              <td class="dialog-instructions" colspan="1">
                <!--Click "Search" to search to find your doctor(s).-->
                {{ $t('myPhysicians.instruction1') }}<br>
              </td>
            </tr>
            <!-- SEARCH CRITIERA -->
            <tr >
              <td colspan="1"> 
                <table width=100% class="tb-mobile-indent">
                  <tr>
                    <td class="tb-background"><div class="tb-pad"/></td>
                    <td class="tb-border">    
                      <div >
                        <table width="100%">
                          <tr>
                            <td class="td-header-space-right">First Name</td>
                            <td class="td-header-space-left"><input type="text" name="txtFirst" v-model="first" v-bind:placeholder="$t('myPhysicians.first')" maxlength="40" /></td>
                            <td class="td-header-space-right">Last Name</td>
                            <td class="td-header-space-left"><input type="text" name="txtLast" v-model="last" v-bind:placeholder="$t('myPhysicians.last')" maxlength="40" /></td>
                            <td class="td-header-space-right">Zipcode</td>
                            <td class="td-header-space-left"><input type="text" name="txtZipcode"  v-model="zipcode" v-bind:placeholder="$t('myPhysicians.zipcode')" maxlength="10" /></td>
                          </tr>
                          <tr>  
                            <td class="td-header-space-right">Phone</td>
                            <td class="td-header-space-left"><input type="text" name="txtPhone"  v-model="phone" v-bind:placeholder="$t('myPhysicians.phone')" maxlength="13" /></td>
                            <td class="td-header-space-right">License Number</td>
                            <td class="td-header-space-left"><input type="text" name="txtLicenseNumber"  v-model="licenseNumber" v-bind:placeholder="$t('myPhysicians.first')" maxlength="50" /></td>
                            <td class="td-header-space-right">National Provider</td>
                            <td class="td-header-space-left"><input type="text" name="txtNationalProvider"  v-model="nationalProvider" v-bind:placeholder="$t('myPhysicians.first')" maxlength="50" /></td>
                          </tr>
                          <tr>
                            <!--<td class="td-header-space-right" colspan="3">Drug Enforcement Agency Id</td>
                            <td class="td-header-space-left"><input type="text" /></td>-->
                            <td class="dialog-search" colspan="6">
                              <br>
                              <input type="button" class="dialog-input-button" v-on:click="search" v-bind:value="$t('myPhysicians.search')">
                              <input type="button" class="dialog-input-button" v-on:click="clear" v-bind:value="$t('myPhysicians.clear')">
                            </td>
                          </tr>
                        </table>
                      </div>
                    </td>
                    <td class="tb-background"><div class="tb-pad"/></td>
                  </tr>
                </table>
              </td>
            </tr>            
            <!-- SEARCH RESULT INSTRUCTIONS -->
            <tr v-if="this.searchResultsLength > 0">
              <td class="dialog-instructions" colspan="1">
                <!--Click "Search" to search to find your doctor(s).-->
                Below is a list of physicians that matched your search, Select "Join" to be added to a physician's medical practice.
              </td>
            </tr>
            <!-- SEARCH RESULTS HEADERS-->
            <tr v-if="this.searchResultsLength > 0">
              <td class="tb-background" colspan="1"> 
                <br>
                <table width=100% border="0">
                  <tr>
                    <td class="tb-background"><div class="tb-pad"/></td>
                    <td class="tb-holder">
                      <table border="0" width="100%">
                        <thead>
                          <tr>
                            <th class="tb-header">
                              <!--Physician-->
                              {{ $t('myPhysicians.header1') }}
                            </th>
                            <th class="tb-header">
                              <!--License-->
                              {{ $t('myPhysicians.header2') }}
                            </th>
                            <th class="tb-header">
                              <!--National Provider Id-->
                              {{ $t('myPhysicians.header3') }}
                            </th>
                            <th class="tb-header">
                              <!--Practice-->
                              {{ $t('myPhysicians.header4') }}
                            </th>
                          </tr>
                        </thead>
                      </table> 
                    </td>
                    <td class="tb-background"><div class="tb-pad"/></td>
                  </tr>
                </table>
              </td> 
            </tr>
            <!-- SEARCH RESULTS -->
            <tr v-if="this.searchResultsLength > 0">
              <td colspan="1"> 
                <table class="tb-mobile-indent" width=100%>
                  <tr>
                    <td class="tb-background"><div class="tb-pad"/></td>
                    <td class="tb-holder">    
                      <div class="scrollable-table tb-border">
                        <table border="0" width="100%">
                          <tbody>
                            <tr v-for="item in this.searchResults" :key="item.userId" class="border-dots">
                              <td class="tb-data">
                                {{ item.first + ' ' + item.last + ( (item.titles == '') ? '' : ', ' + item.titles ) + '.' }}
                              </td>                      
                              <td class="tb-data"> 
                                {{ item.licenseNumber }}
                              </td>
                              <td class="tb-data">
                                {{ item.nationalProviderId }}
                              </td>
                              <td class="tb-data">
                                  <input type="button" class="dialog-input-button" :name="cmdJoin" v-on:click="join(item.userId)" v-bind:value="$t('myPhysicians.join')" >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                    <td class="tb-background"><div class="tb-pad"/></td>
                  </tr>  
              </td> 
            </tr>

            <tr>
              <td class="dialog-instructions" colspan="1">
                <!--Below is a list of your current doctors.-->
                {{ $t('myPhysicians.instruction2') }} &nbsp;
                <input type="button" class="dialog-input-button" :name="cmdRefresh" v-on:click="refresh" v-bind:value="$t('myPhysicians.refresh')" >
              </td>
            </tr>
            <!-- PHYSICIAN HEADERS -->
            <tr v-if="this.physicianLength > 0">
              <td class="tb-background" colspan="1"> 
                <br>
                <table width=100% border="0">
                  <tr>
                    <td class="tb-background"><div class="tb-pad"/></td>
                    <td class="tb-holder">
                      <table border="0" width="100%">
                        <thead>
                          <tr>
                            <th class="tb-header">
                              <!--Physician-->
                              {{ $t('myPhysicians.header1') }}
                            </th>
                            <th class="tb-header">
                              <!--License-->
                              {{ $t('myPhysicians.header2') }}
                            </th>
                            <th class="tb-header">
                              <!--National Provider Id-->
                              {{ $t('myPhysicians.header3') }}
                            </th>
                            <th class="tb-header">
                              <!--Practice-->
                              {{ $t('myPhysicians.header4') }}
                              
                            </th>
                          </tr>
                        </thead>
                      </table> 
                    </td>
                    <td class="tb-background"><div class="tb-pad"/></td>
                  </tr>
                </table>
              </td> 
            </tr>
            <!-- PHYSICIANS -->
            <tr v-if="this.physicianLength > 0">
              <td colspan="1"> 
                <table class="tb-mobile-indent" width=100%>
                  <tr>
                    <td class="tb-background"><div class="tb-pad"/></td>
                    <td class="tb-holder">    
                      <div class="scrollable-table tb-border">
                        <table border="0" width="100%">
                          <tbody>
                            <tr v-for="item in this.physicians" :key="item.userId" class="border-dots">
                              <td class="tb-data">
                                {{ item.first + ' ' + item.last + ( (item.titles == '') ? '' : ', ' + item.titles ) + '.' }}
                              </td>                      
                              <td class="tb-data"> 
                                {{ item.licenseNumber }}
                              </td>
                              <td class="tb-data">
                                {{ item.nationalProviderId }}
                              </td>
                              <td class="tb-data">
                                  <input type="button" class="dialog-input-button" :name="cmdLeave" v-on:click="remove(item.userId)" v-bind:value="$t('myPhysicians.leave')" >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                    <td class="tb-background"><div class="tb-pad"/></td>
                  </tr>  
              </td> 
            </tr>
            <tr>
              <td id="dialog-input-field-finished" colspan="1">  
                <input type="button" class="dialog-input-button" v-on:click="finished" v-bind:value="$t('myPhysicians.finished')">
              </td>
            </tr>
          </table>

        </td>
        <td  style="width:5%"></td>
      </tr>
      <tr>
        <td id="main-table-row3" colspan="1" > 
        </td>
      </tr>
    </table>
  </div>
</template>

<script>

import messageBox from './../common/message-box'
//import confirmMessageBox from './../common/confirm-message-box'

const { API } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )
const { SUPPORT } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

export default {
  name: 'member-myPhysicians',
  data() {
      return {
          physicians:[],
          physicianLength:0,
          searchResults:[],
          searchResultsLength:0,
          first:'',
          last:'',
          zipcode:'',
          phone:'',
          licenseNumber:'',
          nationalProvider:'',
          isProcessing:false
      }
  },
  methods: {
    load()
    {
      try
      {
        SUPPORT.showServiceMenus();
         
        API.readPhysicians(window.sessionKey, 
                          1, //oppCode - CURRENT PHYSICIANS, 
                          '', //first,
                          '', //last,
                          '', //zipcode,
                          '', //phone,
                          '', //licenseNumber,
                          '', //nationalProviderId,
                          '', //drugEnformcementAgencyId, 
                          this.$i18n.locale)
        .then(response => {
          if(response.data.hasError == true)
          {
            this.isProcessing = false;
            this.$generalMessage(messageBox, response.data.errorMessage);
            SUPPORT.securityCheck(response.data.errorId);
          }
          else
          {
            this.physicians = response.data.physicians;
            this.physicianLength = response.data.length; 
          } 
        }).catch( e =>
        {
          this.$generalMessage( messageBox, e );            
        })
      }
      catch(e)
      {
        this.$generalMessage( messageBox, e );
      } 
    },
    clear()
    {
      this.first = '';
      this.last = '';
      this.zipcode = '';
      this.phone = '';
      this.licenseNumber = '';
      this.nationalProvider = '';
      this.searchResults = [];
      this.searchResultsLength = 0;
    },
    search()
    { 
      if( (this.first.length < 2) &&
        (this.last < 2) &&
        (this.zipcode < 2) &&
        (this.phone < 2) &&
        (this.licenseNumber < 2) &&
        (this.nationalProvider < 2) )
      {
        this.$generalMessage( messageBox, this.$t('myPhysicians.invalidSearch') );
        return;
      }

      API.readPhysicians(window.sessionKey, 
                          2, //oppCode - SEARCH PHYSICIANS, 
                          this.first, //first,
                          this.last, //last,
                          this.zipcode, //zipcode,
                          this.phone, //phone,
                          this.licenseNumber, //licenseNumber,
                          this.nationalProvider, //nationalProviderId,
                          '', //drugEnformcementAgencyId NOT USED CURRENTLY, 
                          this.$i18n.locale)
      .then(response => {
        if(response.data.hasError == true)
        {
          this.isProcessing = false;
          this.$generalMessage(messageBox, response.data.errorMessage);
          SUPPORT.securityCheck(response.data.errorId);
        }
        else
        {
          this.searchResults = response.data.physicians;
          this.searchResultsLength = response.data.length;
        } 
      }).catch( e =>
      {
        this.$generalMessage( messageBox, e );            
      }) 
    },
    join(id) 
    {
    
      API.createPhysician(window.sessionKey, 
                        id, //PhysicianId,
                        this.$i18n.locale)
      .then(response => {
        if(response.data.hasError == true)
        {
          this.isProcessing = false;
          this.$generalMessage(messageBox, response.data.errorMessage);
          SUPPORT.securityCheck(response.data.errorId);
        }
        else
        {
          // REMOVE JOINGING PHYSICIAN FROM SEARCH LIST
          var index = this.searchResults.findIndex((e) => e.userId == id);
          var lastName = this.searchResults[index].last;
          this.searchResults.splice(index, 1);
          this.searchResultsLength = this.searchResults.length;

          // REFRESH PHYSICIANS LIST
          this.physicians = response.data.physicians;
          this.physicianLength = response.data.length; 
          // "A request to join Dr. " + lastName + "'s medical practice has been submitted."
          var msg = this.$t('myPhysicians.msgJoin1') + " " + lastName + this.$t('myPhysicians.msgJoin2');
          this.$generalMessage( messageBox, msg ); 
        } 
      }).catch( e =>
      {
        this.$generalMessage( messageBox, e );            
      })
    },    
    refresh()
    {
      API.readPhysicians(window.sessionKey, 
                          1, //oppCode - CURRENT PHYSICIANS, 
                          '', //first,
                          '', //last,
                          '', //zipcode,
                          '', //phone,
                          '', //licenseNumber,
                          '', //nationalProviderId,
                          '', //drugEnformcementAgencyId, 
                          this.$i18n.locale)
        .then(response => {
          if(response.data.hasError == true)
          {
            this.isProcessing = false;
            this.$generalMessage(messageBox, response.data.errorMessage);
            SUPPORT.securityCheck(response.data.errorId);
          }
          else
          {
            this.physicians = response.data.physicians;
            this.physicianLength = response.data.length; 
          } 
        }).catch( e =>
        {
          this.$generalMessage( messageBox, e );            
        })
    },
   /*  remove(id)
    {
       this.$generalMessage(confirmMessageBox, response.data.errorMessage);

    } */
    remove(id) 
    {
      API.deletePhysician(window.sessionKey, 
                        id, //PhysicianId,
                        this.$i18n.locale)
      .then(response => {
        if(response.data.hasError == true)
        {
          this.isProcessing = false;
          this.$generalMessage(messageBox, response.data.errorMessage);
          SUPPORT.securityCheck(response.data.errorId);
        }
        else
        {
          var index = this.physicians.findIndex((e) => e.userId == id);
          var lastName = this.physicians[index].last;

          this.physicians = response.data.physicians;
          this.physicianLength = response.data.length; 
          // "You have successfully left Dr. " + lastName + "'s medical practice."
          var msg = this.$t('myPhysicians.msgLeave1') + " " + lastName + this.$t('myPhysicians.msgLeave2');
          this.$generalMessage( messageBox, msg );
        } 
      }).catch( e =>
      {
        this.$generalMessage( messageBox, e );            
      })
    },
    finished()
    {
      //this.$router.push( { path: "/members/c19-daily-questionnaire"} );
      if(window.defaultDailyQuestionnaireTypeId == 1) // COVID
      {
        this.$router.push( { path: "/members/c19-daily-questionnaire"} );
      }
      else if(window.defaultDailyQuestionnaireTypeId == 2) // FIT FOR DUTY
      {
        this.$router.push( { path: "/members/daily-questionnaire"} );
      }
      else if(window.defaultDailyQuestionnaireTypeId == 3)  // DASHBOARD
      {
        this.$router.push( { path: "/members/dashboard"} );
      }
      this.isProcessing = false;
    },
  },
  mounted () {
    // SHOW TOP OF VIEW
    window.scrollTo(0, 0);
    
    this.load();
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/global.css";

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{
  // BEGIN SIGNON DIALOG STYLES
  #main-table-screen
  {
    background-color:gray;
    padding: 0px;
    margin: 0px;
    width:100%;
    margin-bottom:0px;
    display:table;
    max-width:100%;
    min-width:100%;
  }
  #main-table-row1
  {
    height:32px; 
  }
  #main-table-row2-dialog-container-td
  {
    width:95%;
    padding-left: 5%;
  }
  .dialog-table-radius
  {
    border-radius: 15px !important;
    overflow:hidden;
  }
  #dialog-physician
  {
    height:55px;
    background-color:#4682B4;
    color:white;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
  #dialog-physician-title
  {
    vertical-align:bottom;
    text-align: center;
    padding-top:10px;
    padding-bottom:10px;
    font-family:'Arial Black';
    font-size: 22pt;
    font-weight: 600;
  }
  .dialog-instructions
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    text-align: justify;
    padding-top:15px;
    padding-left:15px;
    padding-right:15px;
    padding-bottom:0px;
  }
  .dialog-body
  {
    color:white;
    background-color:#343F68;
    padding:15px;
  }
  .tb-data
  {
    color:white;
    background-color:#343F68;
    text-align: justify;
    font-family:'Lato';
    padding:5px;
  }
  .td-header-space-left
  {
    color:white;
    background-color:#343F68;
    text-align: justify;
    font-family:'Lato';
    padding-left:5px;
  }
  .tb-mobile-indent
  {
    padding:10px;
    background-color:#343F68;
  }
  .td-header-space-right
  {
    color:white;
    background-color:#343F68;
    text-align: justify;
    font-family:'Lato';
    padding-left:5px;
  }
  .dialog-search{
    color:white;
    background-color:#343F68;
    text-align: justify;
    font-family:'Lato';
    padding-left:10px;
    padding-bottom:10px;
  }
  .tb-header
  {
    display:none;
    /* color:white;
    background-color:#343F68;
    text-align: justify;
    font-family:'Lato';
    background-color:#343F68;
    text-align: center;
    font-weight:700; */
  }
  .border-dots
  {
    //border-bottom-style:none;
    border-bottom-style:dashed;
    border-bottom-width:1px !important;
    border-bottom-color:#4682B4 !important;
  }
  #table-header
  {
    display:none;
  }
  #dialog-input-field-finished
  {
    height:30px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    padding-right:8px;
    padding-bottom:50px;
  }  
  .dialog-input-button
  {
    color:white;
    height:35px;
    background-image: linear-gradient(#4682B4,#4682B4); // STRANGE MOBILE INHERITANCE SHIT
    vertical-align: middle !important;
  }
  #main-table-row3
  {
    height:60px;
  }
  .result-col-width-name
  {
    width:100%;
  }
  .result-col-width-date
  {
    width:100%;
  }
  .result-col-width-check
  {
    width:100%;
  }
  #dialog-input-field-accept-decline
  {
    color:white;
    background-color:#343F68;
    width:100%;
    padding-bottom: 10px;
    padding-top: 10px;
  }
  .scrollable-table
  {
    height:150px;
    overflow-y:auto;
    border:solid;
    border-width: 1px;
    border-color: #343F68;
  }
  .tb-pad
  {
    display: none;
    //width:0px;
  }
  .tb-holder
  {
    width:100%;
  }
  .tb-background
  {
    background-color:#343F68;
  }
  .tb-border
  { 
    border:1px solid white;
  }
  // END DIALOG STYLES
}

//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px)  
{
  // BEGIN SIGNON DIALOG STYLES
  #main-table-screen
  {
    background-color:gray;
    padding: 0px;
    margin: 0px;
    width:100%;
    margin-bottom:0px;
    display:table;
    max-width:100%;
    min-width:100%;
  }
  #main-table-row1
  {
    height:55px; 
  }
  #main-table-row2-dialog-container-td
  {
    width:90%;
  }
  .dialog-table-radius
  {
    border-radius: 15px !important;
    overflow:hidden;
  }
  #dialog-physician
  {
    height:40px;
    width:300px;
    background-color:#4682B4;
    color:white;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
  #dialog-physician-title
  {
    vertical-align:bottom;
    padding-top:10px;
    padding-bottom:10px;
    font-family:'Lato';
    font-size: 22pt;
    font-weight: 600;
  }
  .dialog-instructions
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    text-align: justify;
    padding-top:15px;
    padding-left:25px;
    padding-right:25px;
    padding-bottom:0px;
  }
  .dialog-body
  {
    color:white;
    background-color:#343F68;
    text-align: justify;
    padding:25px;
  }
  .tb-data
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    text-align: center;
    /* padding-left:40px;
    padding-right:40px; */
    width:25%;
  }
  .td-header-space-left
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    text-align: left;
    padding-left:3px;
    padding-right:0px;
    padding-top: 5px;
  }
  .tb-mobile-indent
  {
    
  }
  .td-header-space-right
  {
   font-family:'Lato';
    color:white;
    background-color:#343F68;
    text-align: right;
    padding-left:0px;
    padding-right:3px;
    padding-top: 5px;
  }
  .dialog-search{
    color:white;
    background-color:#343F68;
    text-align: justify;
    font-family:'Lato';
    text-align: center;
    padding-bottom: 5px;
  }
  .tb-header
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    text-align: center;
    width:25%;
  }
  .border-dots
  {  
    border-bottom-style:dashed;
    border-bottom-width:1px !important;
    border-bottom-color:#4682B4 !important;
  } 
  #table-header
  {
    display:visible;
  }
  #dialog-input-field-finished
  {
    height:50px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-right:8px;
  }
  .dialog-input-button
  {
    width:90px;
    color:white;
    background-color:#4682B4 ;   
    vertical-align: middle !important;
  }
  #main-table-row3
  {
    height:250px;
  }
  .result-col-width-name
  {
    width:40%;
  }
  .result-col-width-date
  {
    width:40%;
  }
  .result-col-width-check
  {
    width:empty;
  }
  #dialog-input-field-accept-decline
  {
    color:white;
    background-color:#343F68;
    min-width: 150px;
    width:150px;
    max-width: 150px;
    vertical-align: middle;
    text-align: center;
  }
  .scrollable-table
  {
    height:100px;
    overflow-y:auto;
    text-align: center;
    color:white;
    background-color:#343F68;
  }
  .tb-pad
  {
    width:15px;
  }
  .tb-holder
  {
    width:100%;
  }
  .tb-background
  {
    background-color:#343F68;
  }
  .tb-border
  { 
    border:1px solid white;
  }
  // END DIALOG STYLES
}
</style>